import { render, staticRenderFns } from "./buildings.vue?vue&type=template&id=4cbcd11c&scoped=true"
import script from "./buildings.vue?vue&type=script&lang=js"
export * from "./buildings.vue?vue&type=script&lang=js"
import style0 from "./buildings.vue?vue&type=style&index=0&id=4cbcd11c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbcd11c",
  null
  
)

export default component.exports